// DataTable.js
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Table, Button, Divider, Spin, message, Modal, Form, Upload, Input, Select, Image, Space, Popconfirm, Tooltip, Card, Carousel, Typography,Empty } from 'antd';
import APIUtils from '../api/APIUtils';
import WebLinks from '../api/WebLinks';
import { UploadOutlined, PlayCircleOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import constants from '../constants/constants';
import SocialConfigureDefault from '../assets/Social-configure-default.png';
import { CommonContext } from '../Context';
import { trackPageAccess } from '../globalFunctions/GlobalFunctions';
const { Paragraph } = Typography;
const SocialConfigure = () => {
    const [Loading,setLoading]=useState(false);
    const [loadingAsset,setLoadingAsset]=useState(true);
    const [NewModalOpen,setNewModalOpen]=useState(false);
    const [updateRecord,setUpdateRecord]=useState(false);
    const [updateImage,setUpdateImage]=useState(null);
    const [updateVideo,setUpdateVideo]=useState(null);
    const [data,setData]=useState([]);
    const [occupations,setOccupations]=useState([]);
    const [form] = Form.useForm();
    const [visibleVideo, setVisibleVideo] = useState(false);
    const [urlTypeValue, setUrlTypeValue] = useState('CareersSiteJobURL');
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: constants.pageSize,
      total: 0,
    });
    const [videoUrl, setVideoUrl] = useState('');
    const [jobURl,setJobUrl]=useState('');
    const [jobURlParam,setJobUrlParam]=useState('');
    const [countArrayOptions,setCountArrayOptions]=useState([]);
    const [selectModalVisible, setSelectModalVisible] = useState(false);
    const [selectModalType, setSelectModalType] = useState('');
    const [selectImageItems, setSelectImageItems] = useState([]);
    const [selectVideoItems, setSelectVideoItems] = useState([]);
    const [selectTextItems, setSelectTextItems] = useState([]);
    const [selectedText, setSelectedText] = useState('');
    const [selectedImage,setSelectedImage]=useState(null);
    const [selectedVideo,setSelectedVideo]=useState(null);
    const [selectedCarouselIndex, setSelectedCarouselIndex] = useState(0);
    const [jobslist,setJobs]=useState([]);
    const [siteUrlLinks,setSiteUrlLinks]=useState([])
    const [buyerSpendPerAd,setBuyerSpendPerAd]=useState(0)
    const [finalURL,setFinalURL]=useState('');
    const isSelfService= sessionStorage.getItem('isSelfService');
    const isSelfServiceUser = isSelfService === true || isSelfService === "true";
    const [careerSiteDomain,setCareerSiteDomain]=useState(null);
    const [sorter, setSorter] = useState({
      field: 'Occupation',
      order: 'ascend',
    });
    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        sorter: true
      },
      {
        title: 'Occupation',
        dataIndex: 'occupation',
        key: 'occupation',
        sorter: true
      },
      {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        sorter: true
      },
      {
        title: 'Job',
        dataIndex: 'jobTitle',
        key: 'jobTitle',
        sorter: true
      },
      {
        title: 'Promo Image',
        dataIndex: 'socialPostImageURL',
        key: 'promoimage',
        render: (text) => text?<Image src={text} alt="Promo" className='!w-36' />:<Image src={SocialConfigureDefault} alt="Promo" className='!w-36' />,
        align:'center'
      },
      {
        title: 'Promo Video',
        dataIndex: 'socialPostVideoURL',
        key: 'socialPostVideoURL',
        render: (text) =>text?<Tooltip title="Play Video"><Button type='link' onClick={() => handlePlay(text)} icon={<PlayCircleOutlined className='!text-3xl text-teal-500' />}/></Tooltip>:null,
        align:'center'
      },
      {
        title: 'Promo Text',
        dataIndex: 'socialPostText',
        key: 'promotext',
      },
      {
        title: 'Actions',
        key: 'actions',
        align: 'center',
        render: (text, record) => (
          <Space>
            <Button type="primary" size='small' onClick={() => handleUpdate(record.id)}>
              Update
            </Button>
            <Popconfirm
              title="Are you sure to delete this record?"
              onConfirm={ () => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
                <Button type="primary" danger size='small'>
                Delete
              </Button>
            </Popconfirm>
          </Space>
        ),
      },
    ];
    const urlTypeOptions = isSelfService === true || isSelfService === "true"
      ? careerSiteDomain == null
        ? [
            {
              key: 1,
              value: 'ApplyGatewayJobURL',
              label: "Apply Gateway Job URL",
            },
          ]
        : [
          {
            key: 1,
            value: 'HICareersSiteJobURL',
            label: "HI Careers Site",
          },
          {
            key: 2,
            value: 'ApplyGatewayJobURL',
            label: "Apply Gateway Job URL",
          },
        ]
      : [
          {
            key: 1,
            value: 'CareersSiteJobURL',
            label: "Careers Site Job URL",
          },
          {
            key: 2,
            value: 'ApplyGatewayJobURL',
            label: "Apply Gateway Job URL",
          },
          {
            key: 3,
            value: 'LandingPageURL',
            label: "Landing Page URL",
          },
          ...(careerSiteDomain == null ? [] : [{
            key: 4,
            value: 'HICareersSiteJobURL',
            label: "HI Careers Site",
          }]),
        ];
    const commonContext=useContext(CommonContext);
    const buyerId = commonContext.common.buyerId;

    const handleUpdate = (id) => {
      loadOccupations();
      const editRecord = data.find((row)=> row.id===id);
      setUpdateRecord(editRecord);
      setNewModalOpen(true);
      setUpdateImage(editRecord.socialPostImageURL);
      setUpdateVideo(editRecord.socialPostVideoURL);
      // setImageurl(editRecord.socialPostImageURL);
      setUrlTypeValue(editRecord.socialPostURLType);
      setJobUrlParam(editRecord?.socialPostURLParams||'')
      getJobURL(editRecord.occupationId,editRecord?.jobId);
      redirectToJobURL(editRecord?.socialPostURLParamsReplace,editRecord?.socialPostURLParams,"t");
      form.setFieldsValue({
        promoText:editRecord.socialPostText,
        occupation:editRecord?.occupationId?.toString()||null,
        location:editRecord.location,
        spendperad:editRecord.spendPerAd,
        job:editRecord.jobId,
        urlTypes: editRecord.socialPostURLType,
        urltrackingCode: editRecord?.socialPostURLParams||"",
        urltrackingCodeReplace: editRecord?.socialPostURLParamsReplace||"",
        landingPageUrl: editRecord?.socialPostLandingPage||[]
      })
    };

  // Create an array of numbers 
  const generateOptions = () => {
    let countArray=[];
    for (let i = 80; i <= 500; i=i+20) {
      countArray.push(
       {
        value:i,
        label:i
       }
      );
    }
    setCountArrayOptions(countArray);
  };

    const handleDelete = async(id) => {
          setLoading(true);
          const response = await APIUtils.apiCall('DELETE',WebLinks.DeleteSocialConfig+id,null,true,false);
          if(!response.isCatch && response.resultObj.statusCode==="2000"){
             getData(pagination.current);
             getOccupations();
             message.success(response?.resultObj?.message || "Deleted record successfully");
          }else{
              message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
          }
          setLoading(false);
    };
    const getData = async()=>{
        setLoading(true);
        let desc = sorter.order === 'descend' ? "true" : "false";
        const response = await APIUtils.apiCall('GET',WebLinks.GetSocialConfigure+"buyerId="+buyerId+"&limit="+pagination.pageSize+"&pageNo="+pagination.current+"&orderBy="+sorter?.field +"&sortDesc="+desc,null,true,false);
        if(!response.isCatch && response.resultObj.statusCode==="2000"){
            //Added unique key to fix all inner tables opening together
            response.resultObj.data?.map((item,index)=>{
                item.key=index;
            });
            setData(response?.resultObj?.data);
            setBuyerSpendPerAd(response?.resultObj?.socialBudgetPerAd||0);
            setPagination((prev) => ({
              ...prev,
              total: response?.resultObj?.getCount || 0,
            }));
        }else{
            setData([]);
            //message.error(response?.resultObj?.message);
        }
        setLoading(false);
    };

    //Get Job URl
    const getJobURL = async(occupationId, jobId)=>{
      let occupationIdValue=occupationId?occupationId:"";
      let jobIdValue=jobId?jobId:"";
        const response = await APIUtils.apiCall('GET',WebLinks.GetSocialConfigureJobURL+"buyerId="+buyerId+"&occupationId="+occupationIdValue+"&jobId="+jobIdValue);
        if(!response.isCatch && response.resultObj.statusCode==="2000"){
          if(response?.resultObj?.data){
            //const urlJob = new URL(response?.resultObj?.data);
            //const extractedURL = `${urlJob?.protocol}//${urlJob?.host}`;
            setJobUrl(response?.resultObj?.data);
            setCareerSiteDomain(response?.resultObj?.careerSiteDomain||null);
          }else{
            setJobUrl('');
            setCareerSiteDomain(null);
          }
        }else{
            setJobUrl('');
            setCareerSiteDomain(null);
        }
    };
    const getOccupations = async() =>{
        setLoading(true);
        const response = await APIUtils.apiCall('GET',WebLinks.GetSocialOccupations+buyerId+"&limit=25&pageNo=1&orderBy=OccupationId&sortDesc=false",null,true,false);
        if(!response.isCatch && response.resultObj.statusCode==="2000"){
            //Added unique key to fix all inner tables opening together
            response.resultObj.data?.map((item,index)=>{
                item.key=index;
                item.value = item.occupationId.toString();
                item.label = item.occupation;
                item.disabled = !!(response.resultObj.defaultExist && item.occupationId===0);
            });
            setOccupations(response?.resultObj?.data);
        }else{
            setData([]);
            message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
        }
        setLoading(false);
    };

    const getJobs = async() =>{
      setLoading(true);
      const response = await APIUtils.apiCall('GET',WebLinks.GetSocialJobs+buyerId+"&limit=25&pageNo=1&orderBy=OccupationId&sortDesc=false",null,true,false);
      if(!response.isCatch && response.resultObj.statusCode==="2000"){
          //Added unique key to fix all inner tables opening together
          response.resultObj.data?.map((item,index)=>{
              item.value = item.id;
              item.label = item.job;
          });
          setJobs(response?.resultObj?.data);
      }else{
          setJobs([]);
          message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
      }
      setLoading(false);
    };

    const getSiteUrls = async() =>{
      setLoading(true);
      const response = await APIUtils.apiCall('GET',WebLinks.GetSiteUrlLinks+buyerId,null,true,false);
      if(!response.isCatch && response.resultObj.statusCode==="2000"){
          setSiteUrlLinks(response?.resultObj?.data);
      }else{
          setSiteUrlLinks([]);
          message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
      }
      setLoading(false);
    };

    const loadSelectableItems = async (type) => {
      let url = '';
      if (type === 'image') {
        url = `${WebLinks.GetSelectableSocialMediaImages}?buyerId=${buyerId}&limit=20`;
      } else if (type === 'video') {
        url = `${WebLinks.GetSelectableSocialMediaVideos}?buyerId=${buyerId}&limit=20`;
      } else if (type === 'text') {
        url = `${WebLinks.GetSelectableSocialMediaTexts}?buyerId=${buyerId}&limit=20`;
      }
      if (!url) {
        return;
      }
      const response = await APIUtils.apiCall('GET', url, null, true, false);
      if (!response.isCatch && response.resultObj.statusCode === "2000") {
        const items = response?.resultObj?.data || [];
        if (type === 'image') {
          setSelectImageItems(items);
        } else if (type === 'video') {
          setSelectVideoItems(items);
        } else if (type === 'text') {
          setSelectTextItems(items);
        }
        setLoadingAsset(false);
      } else {
        setLoadingAsset(false);
        message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
      }
    };

  const openSelectModal = async (type) => {
    document.querySelectorAll('video').forEach((video) => {
      video.pause();
    });
    setLoadingAsset(true);
    setSelectModalType(type);
    setSelectModalVisible(true);
    setSelectedCarouselIndex(0);
    await loadSelectableItems(type);
  };
    const handleSelectModalCancel = () => {
      setSelectModalVisible(false);
      setSelectModalType('');
    };

    const handleSelectableItemClick = (item) => {
      if (selectModalType === 'image') {
        const url = item.socialPostImageURL;
        if (url) {
          setSelectedImage(url);
          setImageurl('');
          form.setFieldsValue({
            promoImage: [],
          });
        }
      } else if (selectModalType === 'video') {
        const url = item.url || item.videoUrl || item.socialPostVideoURL || item.videoURL;
        if (url) {
          setSelectedVideo(url);
          setVideourl('');
        }
        form.setFieldsValue({
          promoVideo: [],
        });
      } else if (selectModalType === 'text') {
        const text = item.text || item.socialPostText || item.value || item.title || item.description;
        if (text) {
          form.setFieldsValue({ promoText: text });
          setSelectedText(text);
        }
      }
      handleSelectModalCancel();
    };

    const renderSelectionModal = () => {
      const items = selectModalType === 'image'
        ? selectImageItems
        : selectModalType === 'video'
          ? selectVideoItems
          : selectModalType === 'text'
            ? selectTextItems
            : [];
      const title = selectModalType === 'image'
        ? 'Select Promo Image'
        : selectModalType === 'video'
          ? 'Select Promo Video'
          : selectModalType === 'text'
            ? 'Select Promo Text'
            : 'Select Item';

      const emptyDescription = selectModalType === 'text'
        ? 'You do not have any previously used text. Please add or type new promo text.'
        : selectModalType === 'video'
          ? 'You do not have any previously used videos. Please upload a video.'
          : 'You do not have any previously used images. Please upload an image.';

      return (
        <Modal
          title={title}
          open={selectModalVisible}
          onCancel={handleSelectModalCancel}
          footer={null}
          width={650}
          zIndex={2000}
          className="custom-ant-modal"
        >
          <div style={{ minHeight: 300, position: "relative" }}>
            {loadingAsset && (
              <div className="absolute inset-0 flex items-center justify-center bg-white/70 z-[9999]">
                <Spin/>
              </div>
            )}
            {!loadingAsset && (
              items.length > 0 ? (
                selectModalType === "text" ? (
                  <div className="flex flex-col h-full min-h-[320px]">
                    <div className="flex-1 space-y-3 max-h-[600px] overflow-auto pr-1">
                      {items.map((item, index) => {
                        const textValue = item.socialPostText;

                        return (
                          <Card
                            key={index}
                            hoverable
                            onClick={() => setSelectedCarouselIndex(index)}
                            className={`border border-gray-200 cursor-pointer transition-all duration-200 hover:bg-blue-50 hover:border-blue-300 ${selectedCarouselIndex === index
                                ? '!border-blue-500 bg-blue-50 shadow-md'
                                : ''
                              }`}
                          >
                            <Paragraph ellipsis={{ rows: 4 }} className="mb-0">
                              {textValue}
                            </Paragraph>
                          </Card>
                        );
                      })}
                    </div>

                    <div className="flex justify-end gap-2 mt-auto pt-4">
                      <Button onClick={handleSelectModalCancel}>
                        Cancel
                      </Button>

                      <Button
                        type="primary"
                        style={{ textTransform: 'none' }}
                        onClick={() =>
                          handleSelectableItemClick(
                            items[selectedCarouselIndex]
                          )
                        }
                      >
                        Select Text
                      </Button>
                    </div>
                  </div>
                ) : (
                    <div className="flex flex-col h-full min-h-[320px]">
                      <div className="flex-1 flex items-center">
                        <Carousel
                          key={items.length}
                          centerMode
                          centerPadding="40px"
                          slidesToShow={1}
                          arrows
                          afterChange={(current) => setSelectedCarouselIndex(current)}
                          className="bg-gray-400 rounded w-full"
                        >
                          {items.map((item, index) => {
                            const imageUrlCarousel = item.socialPostImageURL;
                            const videoUrlCarousel = item.socialPostVideoURL;

                            return (
                              <div
                                key={index}
                                className="flex justify-center py-4 min-h-[235px]"
                              >
                                <div className="flex justify-center min-h-[235px] w-full">
                                  {selectModalType === "image" && imageUrlCarousel ? (
                                    <Image
                                      preview={false}
                                      src={imageUrlCarousel}
                                      width={320}
                                    />
                                  ) : selectModalType === "video" && videoUrlCarousel ? (
                                    <video
                                      playsInline
                                      controls
                                      style={{ maxHeight: 360 }}
                                    >
                                      <source src={videoUrlCarousel} />
                                    </video>
                                  ) : (
                                    <div className="h-[180px]" />
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </Carousel>
                      </div>

                      <div className="flex justify-end gap-2 w-full mt-4">
                        <Button onClick={handleSelectModalCancel}>
                          Cancel
                        </Button>

                        <Button
                          type="primary"
                          style={{ textTransform: 'none' }}
                          onClick={() =>
                            handleSelectableItemClick(items[selectedCarouselIndex])
                          }
                        >
                          {selectModalType === "image"
                            ? "Select Existing Image"
                            : "Select Video"}
                        </Button>
                      </div>
                    </div>
                )
              ) : (
                <Empty description={emptyDescription} />
              )
            )}
          </div>
        </Modal>
      );
    };

    const handleCancel = () => {
      form.resetFields();
      setImageurl('')
      setSelectedText('');
      setSelectModalVisible(false);
      setSelectModalType('');
      setNewModalOpen(false);
      if(updateRecord){
        setUpdateRecord(null);
      }
      setUrlTypeValue('CareersSiteJobURL');
      setSelectImageItems([]);
      setSelectVideoItems([]);
      setSelectTextItems([]);
      setFinalURL('');
      setUpdateImage(null);
      setUpdateVideo(null);
      setSelectedImage(null);
      setSelectedVideo(null);
      setLoadingAsset(true);
    };
    const onFinish = async (values) => {
      if (imageurl !== '' || selectedImage || updateImage){
        if(values?.promoVideo && values?.promoVideo[0]?.originFileObj){
          if(values?.promoVideo[0]?.originFileObj.type!=="video/mp4"){
            message.error('You can only upload MP4 files!');
          }else{
            saveConfig(values);
          }
        }else{
          saveConfig(values);
        }
      }else{
        message.error("Please select or upload an image.")
      }
    };
  const saveSelectedMediaUrls = async (id) => {
    try {
      const payload = {
        imageUrlExists: !!selectedImage,
        imageUrl: selectedImage || "",
        videoUrlExists: !!selectedVideo,
        videoUrl: selectedVideo || ""
      };
      payload.id = id || updateRecord?.id;
      const response = await APIUtils.apiCall(
        'PUT',
        WebLinks.UpdatePromoImageVideoURL,
        JSON.stringify(payload),
        true,
        false
      );
      if (
        response.isCatch ||
        response?.resultObj?.statusCode !== "2000"
      ) {
        message.error(
          response?.resultObj?.message ||
          "Failed to save selected media"
        );
        return false;
      }
      return true;
    } catch (error) {
      message.error("Failed to save selected media");
      return false;
    }
  };
    const saveConfig=async (values)=>{
      if((values?.occupation?.toString() && values.job) ||(!values?.occupation?.toString() && !values.job)){
        form.setFieldsValue({
          occupation: null,
          job:null,
        })
        message.error("Please select either an occupation or a job.")
      }
      else{
      const formData = new FormData();
        if (imageurl && imageurl !== updateImage) {
          formData.append('Image', imageurl);
        }
        if (videourl && videourl !== updateVideo) {
          formData.append('Video', videourl);
        }
      if(updateRecord){
        formData.append('SocialConfigure.Id', updateRecord.id);
      }
      formData.append('SocialConfigure.BuyerId', buyerId);
      if(values.occupation){
      formData.append('SocialConfigure.OccupationId', values.occupation);
      }
      if(values.location){
      formData.append('SocialConfigure.Location', values.location);
      }
      if(values.job){
      formData.append('SocialConfigure.JobId', values.job);
      }
      formData.append('SocialConfigure.SpendPerAd', values.spendperad);
      formData.append('SocialConfigure.SocialPostText', values.promoText);
      const socialPostURLType = isSelfServiceUser
        ? careerSiteDomain == null ? "ApplyGatewayJobURL" : "HICareersSiteJobURL"
        : values.urlTypes;
      formData.append('SocialConfigure.SocialPostURLType', socialPostURLType);
      if(urlTypeValue==="CareersSiteJobURL" && values?.urltrackingCode){
        formData.append('SocialConfigure.SocialPostURLParams', values.urltrackingCode);
      }
      if(urlTypeValue==="CareersSiteJobURL" && values?.urltrackingCodeReplace){
        formData.append('SocialConfigure.socialPostURLParamsReplace', values.urltrackingCodeReplace);
      }
      if(urlTypeValue==="LandingPageURL" && values?.landingPageUrl){
        formData.append('SocialConfigure.SocialPostLandingPage', values.landingPageUrl);
      }
      try {
        let url= updateRecord?WebLinks.UpdateSocialConfig:WebLinks.AddSocialConfig;
          const response = await fetch(url, {
            method: updateRecord?'PUT':'POST',
            headers: {
              Authorization: "Bearer "+Cookies.get(constants.COOKIE_TOKEN)
            },
            body: formData,
          });
          const responseData = await response.json();
          if (response.ok) {
            if (updateRecord && (selectedImage || selectedVideo)) {
              const mediaSaved = await saveSelectedMediaUrls(updateRecord.id);
              if (!mediaSaved) {
                return;
              }
            }
            if (!updateRecord && (selectedImage || selectedVideo)) {
              const insertedId = responseData?.socialPostInsertedId
              if (insertedId) {
                const mediaSaved = await saveSelectedMediaUrls(insertedId);
                if (!mediaSaved) {
                  return;
                }
              }
            }
            message.success(responseData?.message || "Inserted record successfully");
            handleCancel();
            getData(pagination.current);
          } else {
              message.error(responseData?.message || constants.ERROR_MESSAGE);
          }
        } catch (error) {
          console.error('Error uploading image:', error);
      } 
      } 
    }
    const loadOccupations =async()=>{
      if (!occupations.length > 0) {
        await getOccupations();
      }
    };

  const renderSelectedImagePreview = () => {
    let previewUrl = selectedImage || updateImage;
    const imagePreview = previewUrl
      ? [{
        uid: '-1',
        name: previewUrl?.split('/')?.pop() || 'Image',
        status: 'done',
        url: previewUrl,
        thumbUrl: previewUrl,
      }]
      : [];

    if (!imagePreview.length) {
      return null;
    }
    return (
      <div>
        <Upload
          className="custom-upload-wrap"
          listType="picture"
          fileList={imagePreview}
          maxCount={1}
          showUploadList={{
            showPreviewIcon: true,
            showRemoveIcon: true,
          }}
          onRemove={() => {
            setSelectedImage(null);
            setUpdateImage(null);
          }}
        />
      </div>
    );
  };
  const renderSelectedVideoPreview = () => {
    const previewUrl =
      selectedVideo || updateVideo;
    const videoPreview = previewUrl
      ? [{
        uid: '-1',
        name: previewUrl?.split('/')?.pop() || 'Video',
        status: 'done',
        url: previewUrl,
      }]
      : [];

    if (!videoPreview.length) {
      return null;
    }

    return (
      <div>
        <Upload
          className="custom-upload-wrap"
          listType="picture"
          maxCount={1}
          fileList={videoPreview}
          showUploadList={{
            showPreviewIcon: false,
            showRemoveIcon: true,
          }}
          onRemove={() => {
            setSelectedVideo(null);
            setUpdateVideo(null);
          }}
        />
      </div>
    );
  };

  const renderUpdateImageFields = () => {
    return (
      <div className="mb-5">
        <div className="flex flex-wrap items-start gap-3">
          <div>
            <Button type="default" onClick={() => openSelectModal('image')}>
              Select Existing Image
            </Button>
            {renderSelectedImagePreview()}
          </div>
          <div>
            <Form.Item
              name="promoImage"
              className="!mb-0"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) {
                  return e;
                }
                return e?.fileList || [];
              }}
            >
              <Upload
                name="logo"
                className="custom-upload-wrap"
                listType="picture"
                accept=".png,.jpg,.jpeg"
                beforeUpload={() => false}
                onChange={(e)=>onUploadChange(e)}
                maxCount={1}
                onRemove={() => {
                  setImageurl('');
                }}
              >
                <Button icon={<UploadOutlined />}>
                  Upload New Image
                </Button>
              </Upload>
            </Form.Item>
            <div className="mt-2">
              <i>(Requirements: JPG or PNG. Min Width 600px / Ratio 1:1 (Square) or 4:5)              </i>
            </div>
            <div className="mt-2">
              <i>Recommended: Have the text 'We Are Hiring' in the image</i>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderUpdateVideoFields = () => {
    return(
      <div className="mb-5">
        <div className="flex flex-wrap items-start gap-3">
          <div>
            <Button type='default' onClick={() => openSelectModal('video')}>
              Select Video
            </Button>
            {renderSelectedVideoPreview()}
          </div>
          <div>
            <Form.Item
              name="promoVideo"
              className="!mb-0"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) {
                  return e;
                }
                return e?.fileList || [];
              }}
            >
              <Upload
                className="custom-upload-wrap"
                name="videoPromo"
                listType="picture"
                accept="video/mp4"
                beforeUpload={()=>false}
                onChange={onVideoUploadChange}
                maxCount={1}
                onRemove={() => {
                  setVideourl('');
                }}
              >
                <Button icon={<UploadOutlined />}>
                  Click to add Promo Video
                </Button>
              </Upload>
            </Form.Item>
            <div className="mt-2">
              <i>(MP4 file only)</i>
            </div>
          </div>
        </div>
      </div>
    );
  };
    const handleTableChange = (pagination, filters, sorter) => {
      setPagination(pagination);
      if(sorter?.field!==undefined){
        setSorter(sorter);
      }
    };
    const handlePlay = (url) => {
      setVideoUrl(url);
      setVisibleVideo(true);
    };
  
    const handleCancelVideo = () => {
      setVideoUrl('');
      setVisibleVideo(false);
    }
    const [imageurl,setImageurl]=useState('');
    const [videourl, setVideourl] = useState('');
    const onUploadChange=(e)=>{
      const imageUrl = e.fileList[0].originFileObj;
      setImageurl(imageUrl);
      setSelectedImage(null);
      setUpdateImage(null);
    }
    const onVideoUploadChange = (e) => {
      const videoFile = e.fileList?.[0]?.originFileObj;
      if (videoFile) {
        setVideourl(videoFile);
        setSelectedVideo(null);
        setUpdateVideo(null);
      } else {
        setVideourl('');
      }
    };
    const handleImageLoad = (e) => {
      const { naturalWidth, naturalHeight } = e.target; // Get image dimensions
      const aspectRatio = naturalWidth / naturalHeight;
       if ( (aspectRatio !== 1 && aspectRatio !== 4 / 5)) {
          message.error('Image requirements not matching.');
          setImageurl('');
      }
    };
    const redirectToJobURL = (codeReplace, trackingCode, loadCall="f", baseUrl) => {
      const normalizeTrackingCode = (trackingCode) =>
        trackingCode?.trim()?.replace(/^[?&]+/, '') || '';
      const replaceTrackingCode = normalizeTrackingCode(codeReplace?codeReplace: form.getFieldValue("urltrackingCodeReplace"));
      const newTrackingCode = normalizeTrackingCode(trackingCode?trackingCode: form.getFieldValue("urltrackingCode"));
      let finalJobUrl = baseUrl || jobURl || "";

      if (!finalJobUrl) {
        setFinalURL('');
        if(loadCall!=="t"){
        message.error("No Career site URL found.");
        }
        return;
      }

      if (newTrackingCode) {
        if (replaceTrackingCode) {
          const escapedReplace = replaceTrackingCode.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const replacePattern = new RegExp(`([?&])${escapedReplace}(?=&|$)`);
          const parameterName = replaceTrackingCode.split('=')[0];
          const escapedParameterName = parameterName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const parameterPattern = new RegExp(`([?&])${escapedParameterName}=[^&]*`);
          const replacement = (match, separator) => `${separator}${newTrackingCode}`;
          finalJobUrl = replacePattern.test(finalJobUrl)
            ? finalJobUrl.replace(replacePattern, replacement)
            : finalJobUrl.replace(parameterPattern, replacement);
        } else {
          finalJobUrl += `${finalJobUrl.includes("?") ? "&" : "?"}${newTrackingCode}`;
        }
        setJobUrlParam(newTrackingCode);
      } else if (replaceTrackingCode) {
        const parameterName = replaceTrackingCode.split('=')[0];
        const escapedParameterName = parameterName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        finalJobUrl = finalJobUrl.replace(new RegExp(`[?&]${escapedParameterName}=[^&]*`), '');
        finalJobUrl = finalJobUrl.replace(/\?&/g, '?').replace(/&&+/g, '&').replace(/[?&]$/, '');
        setJobUrlParam('');
      }
      setFinalURL(finalJobUrl);
      if(loadCall!=="t"){
      window.open(finalJobUrl, '_blank');
      }
    }
    const redirectToLandingURL=()=>{
      let getLandingURL= form.getFieldValue("landingPageUrl");
        if(getLandingURL){
          window.open(getLandingURL, '_blank');
        }else{
          message.error("No Landing page URL found.")
        }
    }
    useEffect(()=>{
        generateOptions();
        getJobs();
        getData();
        getJobURL();
        // getSiteUrls();
    },[pagination.current, pagination.pageSize, sorter.field, sorter.order]);
    useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);
    const renderImageControls = () => (
    <div className="flex flex-wrap items-start gap-3">
      <div>
        <Button onClick={() => openSelectModal('image')}>
          Select Existing Image
        </Button>
        {renderSelectedImagePreview()}
      </div>
      <div>
        <Form.Item
          name="promoImage"
          className="!mb-0"
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            if (Array.isArray(e)) {
              return e;
            }
            return e?.fileList || [];
          }}
          // rules={[{ required: true, message: "Promo image required." }]}
        >
          <Upload
            className="custom-upload-wrap"
            name="logo"
            listType="picture"
            accept=".png,.jpg,.jpeg"
            beforeUpload={() => false}
            onChange={(e) => onUploadChange(e)}
            maxCount={1}
            onRemove={() => {
              setImageurl('');
            }}
          >
            <Button icon={<UploadOutlined />}>
              Upload New Image
            </Button>
          </Upload>
        </Form.Item>
        <div className="mt-2">
              <i>(Requirements: JPG or PNG. Min Width 600px / Ratio 1:1 (Square) or 4:5)              </i>
            </div>
            <div className="mt-2">
              <i>Recommended: Have the text 'We Are Hiring' in the image</i>
        </div>
      </div>
    </div>
  );

  const renderVideoControls = () => (
    <div className="flex flex-wrap items-start gap-3">
      <div>
        <Button onClick={() => openSelectModal('video')}>
          Select Video
        </Button>
        {renderSelectedVideoPreview()}
      </div>
      <div>
        <Form.Item
          name="promoVideo"
          className="!mb-0"
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            if (Array.isArray(e)) {
              return e;
            }
            return e?.fileList || [];
          }}
        >
          <Upload
            className="custom-upload-wrap"
            name="videoPromo"
            listType="picture"
            accept="video/mp4"
            beforeUpload={() => false}
            onChange={onVideoUploadChange}
            maxCount={1}
            onRemove={() => {
              setVideourl('');
            }}
          >
            <Button icon={<UploadOutlined />}>
              Click to add Promo Video
            </Button>
          </Upload>
        </Form.Item>
        <div className="mt-2"><i>(MP4 file only)</i></div>
      </div>
    </div>
  );
    return(
    <div>
        <Spin spinning={Loading}>
            <div className='flex flex-wrap justify-between items-center'>
                <div className='uppercase font-bold text-xl'>Social Media Promo Configuration</div>
                <div>
                    <Button type="primary" style={{ marginRight: '10px' }} onClick={async () => {
                        loadOccupations();
                        setNewModalOpen(true);
                        form.setFieldsValue({
                          urlTypes: isSelfService === true || isSelfService === "true"
                            ? careerSiteDomain !== null
                              ? "HICareersSiteJobURL"
                              : "ApplyGatewayJobURL"
                            : "CareersSiteJobURL",
                          spendperad:buyerSpendPerAd,
                    })
                    }}>
                        Add New
                    </Button>
                </div>
            </div>
            <Divider className='my-3' />
            <Table scroll={{ x: '1000' }} sortDirections={['descend', 'ascend', 'descend']} columns={columns} dataSource={data} pagination={pagination} onChange={handleTableChange}/>
            <Modal
              title={updateRecord?"Edit Configuration":"Add New Configuration"}
              open={NewModalOpen}
              onCancel={handleCancel}
              destroyOnHidden={true}
              okText={<span className="capitalize">Save</span>}
              onOk={() => form.submit()}
              style={{ top: 20 }}
              width={800}
            >
                <Form form={form} name="form_in_modal" layout="vertical" onFinish={onFinish}>
                    <Card>
                    <Form.Item
                        name="occupation"
                        label="Occupation"
                        // rules={[
                        //     {
                        //     required: true,
                        //     message: "Required field",
                        //     },
                        // ]}
                    >
                        <Select allowClear placeholder="Select Occupation" options={occupations} onChange={(e)=>getJobURL(e)}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase()?.includes(input?.trim()?.toLowerCase()) ||
                          option?.value?.toString()?.toLowerCase()?.includes(input?.trim()?.toLowerCase())
                        }
                        />
                    </Form.Item>
                    <Form.Item
                      name="location"
                      label="Location"
                    >
                      <Input />
                    </Form.Item>
                    <div className='mb-3 mt-3'>
                    <span className='text font-bold'>OR</span>
                    </div>
                    <Form.Item
                        name="job"
                        label="Job"
                        // rules={[
                        //     {
                        //     required: true,
                        //     message: "Required field",
                        //     },
                        // ]}
                    >
                      <Select allowClear  placeholder="Select Job" options={jobslist} 
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase()?.includes(input?.trim()?.toLowerCase()) ||
                          option?.value?.toString()?.toLowerCase()?.includes(input?.trim()?.toLowerCase())
                        }
                      />
                    </Form.Item>
                    </Card>
                    <div className="ant-form-item-label mt-5 mb-3">
                      <label>
                        Promo Image
                      </label>
                    </div>
                    {updateRecord?renderUpdateImageFields():(
                      <div className="mb-5">
                      {renderImageControls()}
                      </div>
                    )}
                    <Form.Item hidden>
                      <Image src={imageurl}  onLoad={handleImageLoad}/>
                    </Form.Item>
                    <div className="ant-form-item-label mt-5 mb-3">
                      <label>
                        Promo Video
                      </label>
                    </div>
                    {updateRecord&&updateRecord.socialPostVideoURL ? renderUpdateVideoFields() : (
                      <div className="mb-5">
                        {renderVideoControls()}
                      </div>
                    )} 
                    <div className='mb-4'>
                      <Button type='default' onClick={() => openSelectModal('text')}>
                        Use Previous Text
                      </Button>
                    </div>                
                    <Form.Item
                        name="promoText"
                        label="Promo Text"
                        rules={[
                            {
                            required: true,
                            message: "Required field",
                            },
                        ]}
                    >
                        <Input.TextArea rows={5}/>
                    </Form.Item>
                    <Form.Item
                        name="spendperad"
                        label="Spend Per Ad"
                        rules={[
                            {
                            required: true,
                            message: "Required field",
                            },
                        ]}
                    >
                        <Select options={countArrayOptions} />
                    </Form.Item>
                    {!isSelfServiceUser && <Form.Item
                        name="urlTypes"
                        label="Send clicks to URL type"
                        // rules={[
                        //     {
                        //     required: true,
                        //     message: "Required field",
                        //     },
                        // ]}
                    >
                        <Select
                          onChange={(value) => {
                            setUrlTypeValue(value);
                            setFinalURL('');
                            form.setFieldsValue({ sendClickstoURL: undefined });
                          }}
                          options={urlTypeOptions}
                        />
                    </Form.Item>}
                    {/* {(urlTypeValue === "LandingPageURL" || urlTypeValue === "CareersSiteJobURL") && (
                      <Form.Item
                        name="sendClickstoURL"
                        label="Send Clicks to URL"
                      >
                        <Select
                        placeholder="Select URL"
                          onChange={(value) => redirectToJobURL(undefined, undefined, "t", value || jobURl)}
                          options={siteUrlLinks
                            .filter((siteUrl) =>
                              siteUrl.resultType ===
                              (urlTypeValue === "LandingPageURL" ? "Landing Page" : "Careers Site")
                            )
                            .map((siteUrl) => ({
                              value: siteUrl.value,
                              label: siteUrl.displayText,
                            }))}
                        />
                      </Form.Item>
                    )} */}
                    {!isSelfServiceUser && urlTypeValue === "CareersSiteJobURL" 
                    // || urlTypeValue === "LandingPageURL"
                  ?
                    <>
                    <Form.Item
                        name="urlLabel"
                        label="Example of Your URL"
                      >
                        {/* <label>{jobURl+jobURlParam}</label> */}
                        <label>{finalURL || jobURl || ''}</label>
                    </Form.Item>
                    <Space>
                      {/* {updateRecord? */}
                      <Form.Item
                        name="urltrackingCodeReplace"
                        label="Replace this tracking Code"
                      >
                        <Input />
                    </Form.Item>
                    {/* :null} */}
                      <Form.Item
                        name="urltrackingCode"
                        label="Add URL Tracking Codes"
                      >
                        <Input />
                    </Form.Item>
                    <span><i>(Optional)</i><Button type='link' className='pr-1' onClick={()=>redirectToJobURL()}>Click Here</Button>to test</span>
                    </Space>
                    </>
                    : null}
                    {urlTypeValue === "LandingPageURL" && (
                    <div>
                      <Form.Item
                      className='mb-0'
                      name="landingPageUrl"
                      label="Landing Page - Enter custom URL"
                      rules={[
                          {
                          required: true,
                          message: "Required field",
                          },
                          {
                            type: 'url',
                            message: 'Please enter a valid URL (e.g., https://example.com)',
                          }
                      ]}
                      >
                          <Input/>
                      </Form.Item>
                      <span ><i>(Please enter full URL including https://)</i><Button type='link' className='pr-1' onClick={()=>redirectToLandingURL()}>Click Here</Button>to test</span>
                    </div>
                    )}
                </Form>
            </Modal>
            {renderSelectionModal()}
            <Modal
              title="Promo Video"
              open={visibleVideo}
              onCancel={handleCancelVideo}
              footer={null}
              width={800}
            >
              <video
                src={videoUrl}
                controls
                style={{ width: '100%' }}
                autoPlay
              />
            </Modal>
        </Spin>
  </div>
    );
};

export default SocialConfigure;
